import { Navigate } from "react-router-dom";

const ProtectedRoute = ({ children }) => {
    if (!(JSON.parse(localStorage.getItem('userdata'))?.hasOwnProperty("token"))) {
        return <Navigate to="/" replace={true} />;
    }
    return children;

};
export default ProtectedRoute;